<template>
  <panel title="租赁套餐">
    <template v-slot:right>
      <span class="a" @click="$router.push('/normal/rents/new')">
        自定义下单
      </span>
    </template>
    <div style="display: flex; flex-wrap: wrap; justify-content: flex-start">
      <div v-for="(record, index) of records" :key="index" class="mgr10">
        <div
          class="package-div"
          :style="
            'background-image: url(' + record.image + ');background-size:160px'
          "
        >
          <div class="package-div-content">
            <span
              v-for="(config, index) of record.configs"
              :key="config.id"
              class="white font12"
            >
              {{ config.categoryName }}*{{ config.quantity }}{{ config.unit
              }}<span v-if="index != record.configs.length - 1">/</span></span
            >
          </div>

          <div class="package-div-cover"></div>
        </div>
        <div class="content">
          <div class="font14">{{ record.name }}</div>
          <div style="display: flex; justify-content: space-between">
            <div class="red2" style="padding: 2px 4px">
              {{ record.price | currency }}
            </div>
            <div>
              <el-button
                type="primary"
                size="mini"
                style="padding: 2px 4px"
                @click="
                  Permit.isFreeEdition()
                    ? checkTenantValid('place', record)
                    : place(record)
                "
              >
                {{ $t("action.place") }}
              </el-button>
            </div>
          </div>
        </div>
      </div>
      <div
        class="package-div center"
        style="color: rgb(233, 231, 231); font-size: 100px"
        @click="$router.push('/normal/rent-Packages/new?pageSource=Dashboard')"
      >
        +
      </div>
    </div>
  </panel>
</template>

<script>
import { page } from "@/utils/mixins.js";
import RentPackage from "@/api/rentPackage.js";
import UserAuth from "@/api/userAuth";

export default {
  mixins: [page],
  props: ["source", "customerId", "scheduleId"],
  data() {
    return {
      loading: false,
      records: [],
    };
  },
  created() {
    const self = this;
    RentPackage.findWorkbench().then(function (res) {
      if (res.status === 200) {
        self.records = res.data;
      } else {
        self.sysError();
      }
    });
  },
  methods: {
    checkTenantValid(action, row) {
      const self = this;
      UserAuth.checkTenantValid().then(function (res) {
        if (res.status == 200) {
          if (res.data.type == "fail") {
            self.sysResultCheckTenantValid(res.data);
            return;
          }
          if (action == "place") {
            self.place(row);
          }
        } else {
          self.sysError();
        }
      });
    },
    place(row) {
      const self = this;
      if (self.source == "dashboard") {
        self.$router.push({
          name: "rentsNewByRentPackage",
          params: { rentPackageId: row.id },
        });
      } else {
        self.$router.push({
          name: "rentsNewByRentPackage",
          params: { rentPackageId: row.id },
          query: {
            scheduleId: self.scheduleId,
            customerId: self.customerId,
          },
        });
      }
    },
  },
};
</script>
<style scoped>
.package-div {
  height: 200px;
  width: 160px;
  border: 1px solid rgb(233, 231, 231);
  overflow: hidden;
  position: relative;
  margin-bottom: 5px;
}
.content {
  height: 90px;
  width: 160px;
}
.package-div-content {
  position: absolute;
  z-index: 3;
  padding: 0 10px;
  bottom: 5px;
  overflow: hidden;
}
.package-div-cover {
  height: 70px;
  width: 160px;
  position: absolute;
  background: #000000;
  opacity: 0.4;
  z-index: 2;
  bottom: 0px;
}
</style>